<template>
  <div class="text-textColor">
    <!-- loader -->
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute toppest bg-black bg-opacity-80 h-screen w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>

    <div class="h-screen grid grid-cols-2">
      <features></features>
      <div>
        <div class="flex justify-center h-full flex-col px-20">
          <div class="text-textColorGray">
            <div class="py-5 sm:py-10 sm:px-0 px-10">
              <h1 class="text-4xl pb-5 font-bold">Request Trial</h1>
              <h1 class="text-sm">
                Please add your company details to register your company
              </h1>
            </div>
            <!-- login form -->
            <form
              class="w-full sm:px-0 px-10 flex flex-col"
              @submit.prevent="login"
            >
              <transition name="fade">
                <div
                  v-if="resetPasswordEmailSent"
                  class="text-xs border-1.5 border-green-400 mb-6 flex items-center p-2 gap-4 sm:w-4/6"
                >
                  <img class="h-5" src="@/assets/icons/check.png" />
                  <p class="font-bold">
                    We have sent you an email. Follow the instructions outlined
                    on the email on how to reset your password.
                  </p>
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="error"
                  class="text-xs border-1.5 border-red-400 mb-6 flex items-center p-2 gap-4 sm:w-4/6"
                >
                  <img class="h-5" src="@/assets/icons/cross.png" />
                  <p class="font-bold">{{ error }}</p>
                </div>
              </transition>
              <div class="grid grid-cols-2 gap-5">
                <input
                  placeholder="Company Full Name"
                  type="text"
                  required
                  class="text-xs font-semibold rounded-full border-1.5 p-3 mb-6"
                />
                <input
                  placeholder="Company Email"
                  type="email"
                  required
                  class="text-xs font-semibold rounded-full border-1.5 p-3 mb-6"
                />
                <input
                  placeholder="Company Contact Phone"
                  type="email"
                  required
                  class="text-xs font-semibold rounded-full border-1.5 p-3 mb-6"
                />
                <input
                  placeholder="Company Contact Person"
                  type="email"
                  required
                  class="text-xs font-semibold rounded-full border-1.5 p-3 mb-6"
                />
                <input
                  placeholder="Number of users"
                  type="email"
                  required
                  class="text-xs font-semibold rounded-full border-1.5 p-3 mb-6"
                />
                <input
                  placeholder="Physical location"
                  type="email"
                  required
                  class="text-xs font-semibold rounded-full border-1.5 p-3 mb-6"
                />
              </div>
              <div class="pt-5 text-sm font-semibold">
                <input required type="checkbox" />
                <label>
                  Accept our
                  <a href="#" class="text-primary">Terms and Conditions</a>
                </label>
              </div>
              <button
                type="submit"
                class="bg-primary hover:bg-primary text-white p-2 sm:p-3 mt-0 sm:mt-6 rounded-full font-semibold text-sm"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import features from "@/components/carousel/features.vue";
import axios from "axios";
import Loader from "../components/loader/loader.vue";
var qs = require("qs");
export default {
  name: "Login",
  components: {
    features,
    Loader,
  },
  data() {
    return {
      organization: {
        logo: "https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png",
        name: "Sepia",
      },
      type: "password",
      showPasswordIcon: require("@/assets/icons/eye.png"),
      hidePasswordIcon: require("@/assets/icons/eye-crossed.png"),
      info: {
        username: this.$route.query.username,
        password: this.$route.query.password,
        grant_type: "password",
      },
      error: null,
      resetPasswordEmail: null,
      resetPasswordEmailSent: false,
      loading: false,
      showForgotPassword: false,
    };
  },
  methods: {
    showPassword() {
      this.type = this.type === "password" ? "text" : "password";
    },
    resetPassword() {
      this.loading = true;
      let data = {
        Email: this.resetPasswordEmail,
      };
      axios
        .post(
          `${this.getOrganization}/account/forgot/password`,
          qs.stringify(data)
        )
        .then(
          () => {
            this.loading = false;
            this.showForgotPassword = false;
            this.resetPasswordEmailSent = true;
            setTimeout(() => {
              this.resetPasswordEmailSent = false;
            }, 10000);
          },
          () => {
            this.loading = false;
          }
        );
    },
    login() {
      this.loading = true;
      this.error = null;
      const options = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      axios.post("oauth/generate", qs.stringify(this.info), options).then(
        (response) => {
          this.loading = false;
          this.$store.commit("login", response.data);
          this.$store.commit(
            "setOrganization",
            this.$route.params.organization
          );
          if (response.data.passwordChanged == "True") {
            this.$router.replace({
              name: "dashboard",
              params: {
                organization: this.$route.params.organization,
                company: this.getOrganization,
              },
            });
          } else {
            this.$router.replace({
              name: "changePassword",
              params: { company: this.getOrganization },
            });
          }
        },
        (error) => {
          if (error.response) {
            this.error = error.response.data.error_description;
          } else {
            this.error = error.message;
          }
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style scoped>
.toppest {
  z-index: 9999999;
}
</style>
